// Períodos del panel de indicadores. Las fechas se manejan como texto
// YYYY-MM-DD en hora local: es lo que el usuario elige y lo que se compara
// contra la fecha (local) de cada factura.

const dosDigitos = (n) => String(n).padStart(2, "0");

export function aTexto(fecha) {
  return `${fecha.getFullYear()}-${dosDigitos(fecha.getMonth() + 1)}-${dosDigitos(
    fecha.getDate()
  )}`;
}

export function aFecha(texto) {
  const [anio, mes, dia] = texto.split("-").map(Number);
  return new Date(anio, mes - 1, dia);
}

// Fecha local (YYYY-MM-DD) de un timestamp de la API.
export function fechaLocal(iso) {
  return iso ? aTexto(new Date(iso)) : null;
}

export function sumarDias(texto, dias) {
  const fecha = aFecha(texto);
  fecha.setDate(fecha.getDate() + dias);
  return aTexto(fecha);
}

const ultimoDiaDelMes = (fecha) =>
  new Date(fecha.getFullYear(), fecha.getMonth() + 1, 0).getDate();

// Corre una fecha `meses` meses. Un fin de mes cae en el fin del mes de
// destino (30 de septiembre menos un mes es 31 de agosto), y un día que no
// existe en el destino (31 de marzo menos un mes) queda en su último día.
function sumarMeses(texto, meses) {
  const fecha = aFecha(texto);
  const dia = fecha.getDate();
  const esFinDeMes = dia === ultimoDiaDelMes(fecha);
  fecha.setDate(1);
  fecha.setMonth(fecha.getMonth() + meses);
  const ultimo = ultimoDiaDelMes(fecha);
  fecha.setDate(esFinDeMes ? ultimo : Math.min(dia, ultimo));
  return aTexto(fecha);
}

export function diasEntre(desde, hasta) {
  return Math.round((aFecha(hasta) - aFecha(desde)) / 86400000);
}

export const PERIODOS = [
  { value: "mes", label: "Este mes" },
  { value: "mesAnterior", label: "Mes anterior" },
  { value: "trimestre", label: "Este trimestre" },
  { value: "anio", label: "Este año" },
  { value: "ultimos12", label: "Últimos 12 meses" },
  { value: "personalizado", label: "Personalizado" }
];

/** Rango del período elegido. Los períodos en curso ("este mes") se cortan en hoy. */
export function rangoDePeriodo(periodo, personalizado) {
  const hoy = aTexto(new Date());
  const [anio, mes] = hoy.split("-").map(Number);
  const inicioMes = `${anio}-${dosDigitos(mes)}-01`;

  switch (periodo) {
    case "mes":
      return { desde: inicioMes, hasta: hoy };
    case "mesAnterior":
      return { desde: sumarMeses(inicioMes, -1), hasta: sumarDias(inicioMes, -1) };
    case "trimestre": {
      const mesInicio = Math.floor((mes - 1) / 3) * 3 + 1;
      return { desde: `${anio}-${dosDigitos(mesInicio)}-01`, hasta: hoy };
    }
    case "anio":
      return { desde: `${anio}-01-01`, hasta: hoy };
    case "ultimos12":
      return { desde: sumarDias(sumarMeses(hoy, -12), 1), hasta: hoy };
    case "personalizado":
      if (!personalizado?.desde || !personalizado?.hasta) return null;
      return { desde: personalizado.desde, hasta: personalizado.hasta };
    default:
      return null;
  }
}
